import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";
import { fetchConfig } from "utils";

const useFetchSubscription = (id) => {
	const { accessToken } = useTokenStore();
	const fetch = async () => {
		const instance = await InitApi({ accessToken });
		const res = await instance.get(`subscriptions/${id}`);
		return res.data;
	};
	return useQuery(["subscriptions", id], () => fetch(), {
		...fetchConfig,
	});
};

export default useFetchSubscription;
